export default __webpack_public_path__ + "static/media/computer_man.b66f73c2.svg";